var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix mb-0 text-align"},[_c('b-img',{staticClass:"mx-auto d-block img-fluid w-100",staticStyle:{"max-width":"640px"},attrs:{"src":require('@/assets/images/footer/footer.png')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }